import React from 'react'

export const AuroraBaseGrid: React.FC = () => {
  return (
    <div className="absolute inset-0 pointer-events-none transition-opacity duration-700 text-[#181B1D] opacity-[0.05] dark:text-[var(--color-outline-lower,#6C7B84)] dark:opacity-20">
      <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <pattern id="aurora-grid-base-pattern" width="120" height="120" patternUnits="userSpaceOnUse">
            <line x1="0" y1="60" x2="120" y2="60" stroke="currentColor" strokeWidth="1" />
            <line x1="60" y1="0" x2="60" y2="120" stroke="currentColor" strokeWidth="1" />
            <circle cx="60" cy="60" r="1.8" fill="currentColor" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#aurora-grid-base-pattern)" />
      </svg>
    </div>
  )
}

export const AuroraGlowGrid: React.FC = () => {
  return (
    <div className="absolute inset-0 pointer-events-none transition-opacity duration-700 text-white opacity-[0.32] dark:text-[var(--color-outline-lower,#6C7B84)] dark:opacity-20">
      <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <pattern id="aurora-grid-glow-pattern" width="120" height="120" patternUnits="userSpaceOnUse">
            <line x1="0" y1="60" x2="120" y2="60" stroke="currentColor" strokeWidth="1.2" />
            <line x1="60" y1="0" x2="60" y2="120" stroke="currentColor" strokeWidth="1.2" />
            <circle cx="60" cy="60" r="3.5" fill="currentColor" opacity="0.25" />
            <circle cx="60" cy="60" r="2.2" fill="currentColor" />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#aurora-grid-glow-pattern)" />
      </svg>
    </div>
  )
}
